import { DataBean } from "../DataBean";

export class OfficeUser extends DataBean {

    public async getOfficeUserCatalog(idOffice: any, idAccount: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.shared.Report_getOfficeUserCatalog_Number_Number_Number_Number", [idOffice, idAccount, page, recordsPerPage]);
    }

    public async addOfficeUser(idOffice: any, idOfficeRole: any, idAccount: any, idEmployee: any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.orange.bean.admin.OfficeUser_addOfficeUser_Number_Number_Number_Number", [idOffice, idOfficeRole, idAccount, idEmployee]);
    }
    public async deleteOfficeUser(idOfficeUser: any): Promise<any> {
        return this.getCustomService("OrangeBase", "void_deleteOfficeUser_Number", [idOfficeUser]);
    }
}